module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"actress_header":""},"ja":{"actress_header":"で始まる女のコ"}}')
  delete Component.options._Ctor
}
